import { render, staticRenderFns } from "./DepositEdit.vue?vue&type=template&id=22e004f0"
import script from "./DepositEdit.vue?vue&type=script&lang=js"
export * from "./DepositEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports